import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { createWashingMethod } from '@/apis/washingMethods'
import routes from '@/constants/routes'
import useNotification from '@/hooks/useNotification'
import { CreateWashingMethodRequest } from '@/types/apis/washingMethods/CreateWashingMethodRequest'
import { CreateWashingMethodResponse } from '@/types/apis/washingMethods/CreateWashingMethodResponse'

export const useCreateWashingMethod = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const openNotification = useNotification()
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState<CreateWashingMethodResponse>()

  const create = useCallback(
    async (request: CreateWashingMethodRequest) => {
      try {
        setLoading(true)
        const res = await createWashingMethod(request)
        setResponse(res)
        openNotification({ type: 'success', description: t('components.pages.admins.common.create.success') })
        navigate(routes.washingMethods.path)
      } catch {
        openNotification({ type: 'error', description: t('components.pages.admins.common.create.fail') })
      } finally {
        setLoading(false)
      }
    },
    [navigate, openNotification, t]
  )

  return {
    loading,
    createWashingMethod: create,
    response,
  }
}
